var mentions_default = {
  "mentionPalette": "Y0YrL",
  "mention": "Otl3l",
  "mentionViewer": "UO8nk",
  "mentionSuggestionsEntry": "hNm7o",
  "mentionSuggestionsEntryFocused": "_0u3G4",
  "mentionSuggestionsEntryText": "RgcFn",
  "mentionSuggestionsEntryAvatar": "_3bGUs",
  "mentionSuggestions": "OCoNb",
  "cursorDefault": "laTIN",
  "cursorPointer": "Jjz9p"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
